import { cn } from '../../lib/css/className/className';

import { VerticalAlignWithSkinTextPreset } from './types';
import './verticalAlign.css';
import './verticalAlignWithSkin.css';

const cls = cn('verticalAlign');

/**
 * React Hook для применения стилей типографики
 * Задает свойства:
 * - padding-top и padding-bottom для текста и аддона
 * - line-height для текста и текстового аддона
 * - height аддона
 *
 * @internal - хук для создания компонентов библиотеки
 */
export const useInternalVerticalAlignWithSkin = (options: {
    textSize: VerticalAlignWithSkinTextPreset;
    addonType?: 'icon' | 'help' | 'universal';
}): { textClasses: string; captionClasses: string | undefined; addonClasses: string | undefined } => {
    const { textSize, addonType } = options;

    const textPreset = textSize.replace(' + ', '-');
    const hasCaption = textSize.includes('+');

    const textClasses = cls({ text: textPreset, 'addon-type': '' });
    const addonClasses = addonType && cls({ 'addon-type': addonType, addon: true });
    const captionClasses = hasCaption ? cls({ caption: textPreset }) : undefined;

    return { textClasses, captionClasses, addonClasses };
};
